import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GalleryContent from "./components/GalleryContent"
function Gallery(){
    return (
        <div>
            <Header/>
            <GalleryContent />
            <Footer/>
        </div>
    )
}
export default Gallery